export default "__VITE_ASSET__3c063c5b__"